import { gql } from "@apollo/client";


export const CREATE_DEVOTEE_OCCASION = gql`
 mutation createDevoteeOccasion($input: createDevoteeOccasionInput) {
    createDevoteeOccasion(input: $input) {
        occasion_id
        devotee_id
        occasion_name
        occasion_day
        occasion_month
        notes
    }
}
`;


export const UPDATE_DEVOTEE_OCCASION = gql`
mutation updateDevoteeOccasion($input: updateDevoteeOccasionInput) {
    updateDevoteeOccasion(input: $input) {
        occasion_id
        occasion_name
        notes
    }
}
`;

export const DELETE_DEVOTEE_OCCASION = gql`
mutation deleteDevoteeOccasion($occasion_id: ID!) {
    deleteDevoteeOccasion(occasion_id: $occasion_id)
}
`;


export const GET_ALL_DEVOTEE_OCCASIONS = gql`
query getAllDevoteeOccasions {
    getAllDevoteeOccasions {
        occasion_id
        devotee_id
        occasion_name
        occasion_day
        occasion_month
        notes
          devoteesData{
      devotee_id
      devotee_name
     }
    }
}
`;


export const GET_DEVOTEE_OCCASION_BY_ID = gql`
query getDevoteeOccasionById($occasion_id: ID!) {
    getDevoteeOccasionById(occasion_id: $occasion_id) {
        occasion_id
        occasion_name
        occasion_day
        occasion_month
        notes
        devotee_id
    }
}
`;